import { render, staticRenderFns } from "./tuikuanProxyPayment.vue?vue&type=template&id=4c10428c&scoped=true&"
import script from "./tuikuanProxyPayment.vue?vue&type=script&lang=js&"
export * from "./tuikuanProxyPayment.vue?vue&type=script&lang=js&"
import style0 from "./tuikuanProxyPayment.vue?vue&type=style&index=0&id=4c10428c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10428c",
  null
  
)

export default component.exports